"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var AsyncSelect_1 = __importDefault(require("../AsyncSelect"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var ColorControl_1 = __importDefault(require("../ColorControl"));
var ColorPicker_1 = __importDefault(require("../ColorPicker"));
var DatePickers_1 = require("../DatePickers");
var FormGroup_1 = __importDefault(require("../FormGroup"));
var ImageControl_1 = __importDefault(require("../ImageControl"));
var Input_1 = __importDefault(require("../Input"));
var InputAutocomplete_1 = __importDefault(require("../InputAutocomplete"));
var Label_1 = __importDefault(require("../Label/Label"));
var Select_1 = __importDefault(require("../Select"));
var SelectAutocomplete_1 = __importDefault(require("../SelectAutocomplete"));
var SmarttagControl_1 = __importDefault(require("../SmarttagsControl/SmarttagControl"));
var Switch_1 = __importDefault(require("../Switch"));
var Textarea_1 = __importDefault(require("../Textarea"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var TheSelect_1 = __importDefault(require("../TheSelect"));
var TheSelectSimple_1 = __importDefault(require("../TheSelectSimple"));
var DEFAULT_COMPONENT_MAP = {
    autocomplete: InputAutocomplete_1.default,
    checkbox: Checkbox_1.default,
    color: ColorPicker_1.default,
    colorInput: ColorControl_1.default,
    date: DatePickers_1.DatePicker,
    dateTime: DatePickers_1.DateTimePicker,
    default: Input_1.default,
    image: ImageControl_1.default,
    select: Select_1.default,
    selectautocomplete: SelectAutocomplete_1.default,
    smarttag: SmarttagControl_1.default,
    switch: Switch_1.default,
    textarea: Textarea_1.default,
    time: DatePickers_1.TimePicker,
    theselect: TheSelect_1.default,
    theselectsimple: TheSelectSimple_1.default,
    asyncselect: AsyncSelect_1.default,
};
var ErrorText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  position: absolute;\n  margin-top: ", ";\n  left: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  position: absolute;\n  margin-top: ", ";\n  left: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"])), polished_1.rem(11), function (_a) {
    var theme = _a.theme;
    return theme.color.danger;
}, polished_1.rem(3));
var RelativeWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: ", ";\n"], ["\n  position: relative;\n  padding-bottom: ", ";\n"])), polished_1.rem(10));
function default_1(props) {
    var error = props.error, _a = props.type, type = _a === void 0 ? 'default' : _a, label = props.label, required = props.required, className = props.className, _b = props.componentMap, componentMap = _b === void 0 ? DEFAULT_COMPONENT_MAP : _b, restProps = __rest(props, ["error", "type", "label", "required", "className", "componentMap"]);
    var Component = componentMap[type] || componentMap.default;
    if (type === 'checkbox') {
        return (React.createElement(FormGroup_1.default, { className: className },
            React.createElement(RelativeWrapper, null,
                React.createElement(Label_1.default, { required: required },
                    React.createElement(Component, __assign({ error: error }, restProps)),
                    " ",
                    label),
                !!error && React.createElement(ErrorText, { title: error }, error))));
    }
    return (React.createElement(FormGroup_1.default, { className: className },
        label && React.createElement(Label_1.default, { required: required }, label),
        React.createElement(RelativeWrapper, null,
            React.createElement(Component, __assign({ error: error }, restProps)),
            !!error && React.createElement(ErrorText, { title: error }, error))));
}
exports.default = default_1;
var templateObject_1, templateObject_2;
